<template>
  <div class="popup-entry-main">
    <div class="popup-content">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div class="dates">
          <Input
            v-if="createdBy"
            :style="createdByStyling"
            class="dates-input"
            placeholder="Created by"
            :isDisabled="true"
            :inputValue="createdBy"
          />
          <Input
            v-if="updatedBy"
            :style="updatedByStyling"
            class="dates-input"
            placeholder="Updated by"
            :isDisabled="true"
            :inputValue="updatedBy"
          />
        </div>
      </div>
      <div class="body">
        <slot></slot>
      </div>
      <div class="footer">
        <div class="message-box" :style="{ backgroundColor: getBackground() }">
          <div v-for="(s, i) in pSuccessMessages" :key="`success_${i}`" v-html="s"></div>
          <div v-for="(m, i) in pMessages" :key="`message_${i}`" v-html="m"></div>
          <div v-for="(e, i) in pErrorMessages" :key="`error_${i}`" v-html="e"></div>
          <div v-for="(r, i) in pRequiredError" :key="`required_${i}`">
            <a @click="requiredClick(r['Key'] ? r['Key'] : r['key'])">{{ r['Value'] ? r['Value'] : r['value'] }}</a>
          </div>
        </div>
        <button v-if="!viewMode && !disabledSave" @click="saveClick()">
          <img src="https://dsmlib.logistics.systems/Icons/Save.png" />
          {{ saveButton }}
        </button>
        <button v-if="canPrint && (viewMode || disabledSave)" @click="printClick()">
          <img src="https://dsmlib.logistics.systems/Icons/Print.png" />
          {{ printButton }}
        </button>
        <button @click="cancelClick()">
          <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" />
          {{ cancelButton }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';

export default {
  components: {
    Input,
  },
  computed: {
    createdByStyling: function () {
      return {
        "minWidth": "200px",
        "width": `${this.createdBy.length * 8}px`,
      }
    },

    updatedByStyling: function () {
      return {
        "minWidth": "200px",
        "width": `${this.updatedBy.length * 8}px`,
      }
    },
  },
  data: function () {
    return {
      pRequiredError: [],
      pSuccessMessages: [],
      pMessages: [],
      pErrorMessages: [],
    };
  },
  props: {
    title: { type: String, default: 'Title here' },

    createdBy: { type: String, default: '' },
    updatedBy: { type: String, default: '' },

    requiredError: {
      type: Array,
      default: function () {
        return [];
      },
    },
    successMessages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    messages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    errorMessages: {
      type: Array,
      default: function () {
        return [];
      },
    },

    viewMode: { type: Boolean, default: false },
    disabledSave: { type: Boolean, default: false },
    canPrint: { type: Boolean, default: false },

    show: { type: Boolean, default: false },

    saveButton: { type: String, default: 'Save' },
    cancelButton: { type: String, default: 'Cancel' },
    printButton: { type: String, default: 'Print' },
  },
  methods: {
    getBackground: function () {
      if (this.pErrorMessages.length > 0 || this.pRequiredError.length > 0) {
        return 'rgba(255, 121, 121, 0.37)';
      } else if (this.pSuccessMessages.length > 0) {
        return 'rgba(126, 255, 121, 0.37)';
      } else if (this.pMessages.length > 0) {
        return 'rgba(255, 246, 121, 0.37)';
      }
    },
    saveClick: function () {
      this.$emit('save');
    },
    printClick: function () {
      this.$emit('print');
    },
    cancelClick: function () {
      this.$emit('update:show', false);
    },
    requiredClick: function (error) {
      this.$emit('requiredClicked', error);
    },
  },
  mounted() {
    if (this.requiredError) {
      this.pRequiredError = this.requiredError;
    }

    if (this.successMessages) {
      this.pSuccessMessages = this.successMessages;
    }

    if (this.messages) {
      this.pMessages = this.messages;
    }

    if (this.errorMessages) {
      this.pErrorMessages = this.errorMessages;
    }
  },
  watch: {
    requiredError: function (val) {
      this.pRequiredError = val;
      val.forEach((v) => {
        if (this.$refs[v.Key]) {
          this.$refs[v.Key][0].errorMessage = v.Value;
        }
      });
    },
    successMessages: function (val) {
      this.pSuccessMessages = val;
    },
    messages: function (val) {
      this.pMessages = val;
    },
    errorMessages: function (val) {
      this.pErrorMessages = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.popup-entry-main {
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $top-nav-height;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 42px;
  z-index: 999;

  > .popup-content > * {
    padding: 5px;
  }

  > .popup-content {
    width: 100%;
    height: 95%;
    background-color: white;
    border-radius: 3px;
    display: flex;
    flex-direction: column;

    > .header {
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgb(180, 180, 180);

      > .title {
        flex-grow: 1;
        margin-left: 10px;
        font-weight: bolder;
      }

      > .dates {
        display: flex;

        > .dates-input {
          margin: 0 3px;
        }
      }
    }

    > .body {
      overflow-y: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    > .footer {
      border-top: 2px solid rgb(180, 180, 180);
      display: flex;
      align-items: center;

      > .message-box {
        flex-grow: 1;
        margin-right: 10px;
        background-color: rgba(255, 246, 121, 0.37);
        overflow: auto;
        height: 40px;
        max-height: 40px;
        padding-left: 5px;

        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      > button {
        padding: 5px;
        margin: 0 3px;

        > img {
          height: 25px;
        }
      }
    }
  }
}
</style>
